export function getDynamicPatternsSchema(adapter, data) {
    var _a;
    return ((_a = adapter === null || adapter === void 0 ? void 0 : adapter.getDynamicPatternsSchema) === null || _a === void 0 ? void 0 : _a.call(adapter, data)) || { tags: [] };
}
